const kmToMins = (km) => km * 20 || 0

export default kmToMins
